export const RECEIVE_SETTINGS = "SESSION.RECEIVE_SETTINGS";
export const RESET_SETTINGS = "SESSION.RESET_SETTINGS";
export const RECEIVE_USER = "SESSION.RECEIVE_USER";

export const resetSession = {
  type: RESET_SETTINGS,
};
